import { render, staticRenderFns } from "./webs.vue?vue&type=template&id=f18da336&scoped=true"
import script from "./webs.vue?vue&type=script&lang=js"
export * from "./webs.vue?vue&type=script&lang=js"
import style0 from "./webs.vue?vue&type=style&index=0&id=f18da336&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18da336",
  null
  
)

export default component.exports